<!-- 欢迎页面 -->
<template>
  <div class="logo-div">
        <div class="logo-text">
            <img v-if="!hideLogo" src="../../assets/kayi-logo.png"/>
            <div>欢迎来到</div>
            <div><span v-if="!hideLogo">卡易</span>即时通讯系统</div>
        </div>
    </div>
</template>

<script>
export default {
  name: '',
  mixins: [],
  components: {},
  data () {
    return {
      hideLogo: window.httpConfig.hideLogo
    }
  },
  watch: {},
  computed: {},
  created () {},
  mounted () {},
  methods: {},
  beforeDestroy () {},
  destroyed () {},
  beforeUpdate () {},
  updated () {}
}
</script>
<style lang='scss' scoped>
.logo-div {
    height: 100%;
    flex: 1;
    text-align: center;
    position: relative;
    background: #F2F3F5;
    .logo-text{
        position: absolute;
        top: calc(50% - 150px);
        width: 100%;
        opacity: 0.5;
        transform: scale(0.7);
        div{
            font-size: 36px;
            font-weight: 900;
            color: #000000a6;
        }
        img{
            width: 65%;
            max-width: 470px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// packages/chat/src/welcome.vue